import pdfMake from 'pdfmake/build/pdfmake';
import { logoImg } from '../../../../services/others/assets'
import moment from 'moment'
import { fetchOptionsArray } from '../../../order/purchase-order/purchase-order-page/purchase-order-column-model';

export default async (data:any, require:string, getBlob?:any) => {
    console.log(data)
    const vfsFonts = await import("pdfmake/build/vfs_fonts");    
    pdfMake.fonts = {
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        },
        arial: {
            normal: 'arial.ttf',
            bold: 'arialbd.ttf',
            italics: 'ariali.ttf',
            bolditalics: 'arialbi.ttf'
        },
        weiruanyahei: {
            normal: '微软雅黑.ttf',
            bold: '微软雅黑.ttf',
            italics: '微软雅黑.ttf',
            bolditalics: '微软雅黑.ttf'
        }
    }
    const {vfs} = vfsFonts.pdfMake;
    pdfMake.vfs = vfs;

    const subTotalPrice:number = subTotal(data).toFixed(2)
    const currency = data.suplier?.currencyId==1?'NZD':
        (data.suplier?.currencyId==2?'RMB':'USD');
    const gst = (data.suplier?.currencyId==1)?(subTotalPrice*0.15).toFixed(2):0;
    const total = (data.suplier?.currencyId==1)?(subTotalPrice*1.15).toFixed(2):subTotalPrice;

    const optionsArray = await fetchOptionsArray();
    const contents = tableFormat2(data, optionsArray);

    const documentDefinition:any = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [30, 15, 30, 10],

        info: {
            title: data.poNo,
            author: 'Jadcup',
            subject: data.poNo,
            keywords: 'Jadcup',
        },
        
        content: [
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: 150,
                                        stack: [
                                            {
                                                image: logoImg,
                                                width: 48, 
                                                // height: 25,
                                                margin: [0, 0, 0, 5]
                                            }
                                        ]
                                    },
                                    {
                                        width: '*',
                                        text: 'Purchase Order',
                                        alignment: 'center',
                                        fontSize: 18,
                                        // font:'arial',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        width: 200,
                                        text: 'Jadcup - NZ Made 2013 Limited',
                                        alignment: 'right',
                                        fontSize: 9,
                                        margin: [0, 20, 0, 0]
                                    }
                                ]
                            }
                        ]
                    ]
                },
                layout: 'noBorders',
                font: 'Roboto'
            },
            
            // Info blocks section
            {
                margin: [0, 0, 0, 0],
                table: {
                    widths: ['*', '*', '*', '*'],
                    // heights: [120], // Set equal fixed height for all cells
                    body: [
                        [
                            {
                                table: {
                                    widths: ['*'],
                                    heights: [10, 85], // Set fixed heights for header and content

                                    headerRows: 1,
                                    body: [
                                        [{ text: 'Supplier Info', fillColor: '#eeeeee', fontSize: 8, bold: true }],
                                        [{
                                            text: [
                                                `${data.suplier?.suplierName}\n`,
                                                `${data.suplier?.address?.split(',')[0] ?? ''}\n`,
                                                `${data.suplier?.address?.split(',')[1] ?? ''}\n`,
                                                `${data.suplier?.address?.split(',')[2] ?? ''}\n`,
                                                `${data.suplier?.address?.split(',')[3] ?? ''}`
                                              ],
                                            fontSize: 9, font:"weiruanyahei", margin: [0, 5, 0, 0]
                                        }]
                                    ]
                                },
                                layout: {
                                    hLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    vLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    hLineColor: function(_i: number, _node: any) { return '#000'; },
                                    vLineColor: function(_i: number, _node: any) { return '#000'; },
                                },
                                
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    heights: [10, 10, 10, 55], // Set fixed heights for each row

                                    headerRows: 1,
                                    body: [
                                        [{ text: 'Invoice To', fillColor: '#eeeeee', fontSize: 8,bold: true }],
                                        [{ 
                                            text: 'accounts@jadcup.co.nz',
                                            fontSize: 9 
                                        }],
                                        [{ text: 'Deliver To', fillColor: '#eeeeee', fontSize: 8, bold: true }],
                                        [{
                                            stack: [
                                                { text: 'Jadcup', margin: [0, 0, 0, 0] },
                                                { text: '17b Landing Drive Māngere', margin: [0, 3, 0, 0] },
                                                { text: 'Auckland 2022, New Zealand', margin: [0, 0, 0, 0] },
                                                { text: 'Phone: +64 09-282 3988', margin: [0, 3, 0, 0] }
                                            ],
                                            fontSize: 9
                                        }]
                                    ]
                                },
                                layout: {
                                    hLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    vLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    hLineColor: function(_i: number, _node: any) { return '#000'; },
                                    vLineColor: function(_i: number, _node: any) { return '#000'; },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    heights: [10, 85], // Set fixed heights for header and content
                                    headerRows: 1,
                                    body: [
                                        [{ text: 'Delivery Instructions', font: 'Roboto',fillColor: '#eeeeee',fontSize: 8, bold: true }],
                                        [{
                                            text: data.deliveryInstruction || ' ',
                                            fontSize: 9,font:"weiruanyahei"
                                        }]
                                    ]
                                },
                                layout: {
                                    hLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    vLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    hLineColor: function(_i: number, _node: any) { return '#000'; },
                                    vLineColor: function(_i: number, _node: any) { return '#000'; },
                                }
                            },
                            {
                                table: {
                                    widths: ['*'],
                                    heights: [10, 82], // Set fixed heights for header and content
                                    headerRows: 1,
                                    body: [
                                        [{ text: `Purchase Order No: ${data.poNo}`, fillColor: '#eeeeee',fontSize: 10, bold: true }],
                                        [{
                                            stack: [
                                                { text: `Currency: ${currency}`, margin: [0, 5, 0, 0] },
                                                { text: `Order Date: ${data.createdAt ? moment.utc(data.createdAt).local().format('DD MMM YYYY') : " "}`, margin: [0, 5, 0, 0] },
                                                { text: `${data.dueDate ? `Due Date: ${moment(data.dueDate).format('DD MMM YYYY')}` : ""}`, margin: [0, 5, 0, 0] },
                                                { text: `Purchaser: ${data.createdEmployee ? `${data.createdEmployee.firstName || ""} ${data.createdEmployee.lastName || ""}` : ""}`, margin: [0, 5, 0, 0] }
                                            ],
                                            fontSize: 9,
                                            bold: false
                                        }]
                                    ]
                                },
                                layout: {
                                    hLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    vLineWidth: function(_i: number, _node: any) { return 0.7; },
                                    hLineColor: function(_i: number, _node: any) { return '#000'; },
                                    vLineColor: function(_i: number, _node: any) { return '#000'; },
                                }
                            },                            
                        ]
                    ]
                },
                layout: 'noBorders',
                font: 'Roboto'
            },
            {
                margin: [0, 5, 0, 0],
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto'],
                    // heights: [300], // Set the total fixed height for the entire table container
                    body: [
                        [
                            { text: 'Supplier Code', style: 'tableHeader', fillColor: '#eeeeee', font: 'Roboto' , fontSize: 8}, // [left, top, right, bottom]},
                            { text: 'Jadcup Code', style: 'tableHeader', fillColor: '#eeeeee' ,font: 'Roboto', fontSize: 8},
                            { text: 'Product Description', style: 'tableHeader', fillColor: '#eeeeee',font: 'Roboto', fontSize: 8},
                            { text: 'Pcs/Unit', style: 'tableHeader', fillColor: '#eeeeee', alignment: 'right' ,font: 'Roboto', fontSize: 8},
                            { text: 'Unit', style: 'tableHeader', fillColor: '#eeeeee', alignment: 'right' ,font: 'Roboto', fontSize: 8},
                            { text: 'Unit Price', style: 'tableHeader', fillColor: '#eeeeee', alignment: 'right' ,font: 'Roboto', fontSize: 8},
                            { text: 'Amount', style: 'tableHeader', fillColor: '#eeeeee', alignment: 'right' ,font: 'Roboto', fontSize: 8},
                        ],
                        ...contents
                    ]
                },
                fontSize: 8,
                layout: {
                    hLineWidth: function(i: number | undefined, node: any) {
                        if (i === undefined || !node || !node.table || !node.table.body) {
                            return 0; // Fallback to no line if parameters are invalid
                        }
                        return (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0;
                    },                        
                    vLineWidth: function(_i: number, _node: any) { return 0.7; },
                    hLineColor: function(_i: number, _node: any) { return '#000'; },
                    vLineColor: function(_i: number, _node: any) { return '#000'; },
                }
            },       
            // Total section
            {
                margin: [0, 5, 0, 0],
                table: {
                    widths: ['*', 'auto'],
                    body: [
                        [
                            { 
                                stack: [
                                    { text: `IMPORTANT`, bold: true, fontSize: 9 },
                                    { text: `Please check and advise the following to the Purchaser BEFORE the goods are dispatched:` },
                                    { text: `- Price exceptions must be notified otherwise acceptance of this purchase order will be at the price stated\n` },
                                    { text: `- Inform the Purchaser of back orders and expected delivery dates. WE ACCEPT BACK ORDERS\n` },
                                    { text: `- Confirm purchase order acceptance as soon as possible` }
                                ],
                                fontSize: 8,
                            },
                            // { text: 'Total', bold: true, alignment: 'right' },
                            // { text: `${total}`, bold: true, alignment: 'right' }
                            {
                                table: {
                                    widths: ['*'],
                                    heights: data.suplier?.currencyId == 1 ? [20, 20, 20] : [40], // Different heights based on currency
                                    body: data.suplier?.currencyId == 1 ? 
                                        [
                                            // For NZD currency - show subtotal, GST and total
                                            [{ text: `     Subtotal      ${subTotalPrice}\n     GST 15%        ${gst}`, bold: true, alignment: 'right', fontSize: 8, margin: [0, 0, 0, 0] }],
                                            // [{ text: `     GST 15%   ${gst}`, bold: true, alignment: 'right', fontSize: 9 , margin: [0, 0, 0, 0] }],
                                            [{ text: `     Total      ${total}`, bold: true, alignment: 'right', fontSize: 9, margin: [0, 0, 0, 0] }]
                                        ] : 
                                        [
                                            // For other currencies - show only total
                                            [{ text: `     Total      ${total}`, bold: true, alignment: 'right', fontSize: 9, margin: [0, 5, 0, 20] }]
                                        ]
                                },
                                margin: [0, 0, -3, 0], 
                                layout: {
                                    hLineWidth: function() { return 0.7; },
                                    vLineWidth: function() { return 0.7; },
                                    hLineColor: function() { return '#000'; },
                                    vLineColor: function() { return '#000'; }
                                }
                            }                          
                        ]
                    ]
                },
                font: 'Roboto',
                layout: {
                    hLineWidth: function(i: number) { return  0; },
                    vLineWidth: function() { return 0; },
                    hLineColor: function() { return '#000'; },
                }
            }
        ],
        
        styles: {
            tableHeader: {
                bold: true,
                fontSize: 10,
                alignment: 'left'
            }
        },
        
        defaultStyle: {
            font: 'weiruanyahei',
            fontSize: 10
        }
    };

    if (require === 'getBlob') {
        const pdfDocGenerator = pdfMake.createPdf(documentDefinition)
        pdfDocGenerator.getBlob((blob) => {
          console.log(blob, 'blob')
          getBlob(blob)
        })
    }
    if (require === 'print') {
        pdfMake.createPdf(documentDefinition).open()
    }
}

const tableFormat2 = (data:any, optionsArray:any[]) => {
    const poDetailData = data.poDetail.map((res:any) => {
        return [
            res.suplierProductCode?.replace(/\u2011/g, '-') ?? res.rawMaterial?.rawMaterialCode,
            res.rawMaterial?.rawMaterialCode,
            res.rawMaterial?.rawMaterialName?.replace(/\u2011/g, '-'),
            { text: res.unit , alignment: 'right' },
            { text: res.quantity , alignment: 'right' },
            { text: res.unitPrice?.toFixed(3) || '0.000', alignment: 'right' },
            { text: res.price?.toFixed(2) || '18060.00', alignment: 'right' }
        ]
    })
    
    const poOptionData = data.poOption.map((res: any) => {
        const optionLabel = optionsArray.filter((fee: any) => fee.value === res?.optionId)[0]?.label || '';
        return [
            '', 
            '', 
            optionLabel, 
            { text: "", alignment: 'right' },
            { text: '1', alignment: 'right' },
            { text: res.price?.toFixed(2) || '0.00', alignment: 'right' },
            { text: res.price?.toFixed(2) || '0.00', alignment: 'right' }
        ]
    })
    
    let result = data.poOption.length === 0 ? [...poDetailData] : [...poDetailData, ...poOptionData]
    while (result.length < 23) {
        result.push([' ', ' ', ' ', ' ', ' ', ' ', ' ']);
    }
    console.log(result, 'result')
    return result;
    // return res
}

const subTotal = (data:any) => {
    if (!data.poDetail || data.poDetail.length === 0) return 0;
    
    const poDetailTotal = data.poDetail.map((res:any) => {
        return res.price || 0
    }).reduce((accumulator:any, currentValue:any) => {
        return accumulator + currentValue
    }, 0)
    
    const poOptionTotal = data.poOption && data.poOption.length > 0 ? 
        data.poOption.map((res: any) => res.price || 0).reduce((a: number, value: number) => a + value, 0) : 0;
    
    return data.poOption.length === 0 ? poDetailTotal : (poDetailTotal + poOptionTotal)
}
